import React from "react"
import styled from "styled-components"

const PageTitleElement = styled.h2`
  font-size: 18vw;
  font-family: "La Luxes Script";
`

const PageTitle: React.FC = props => {
  return <PageTitleElement {...props}>Made for you</PageTitleElement>
}

export default PageTitle
